/**
 * Decodes HTML entities from a string.
 */
export const decodeHtml = (html: string) => {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
};

/**
 * Strips HTML tags from a string.
 */
export const stripHtml = (html: string) => {
    try {
        const div = document.createElement('div');
        div.innerHTML = String(html || '');
        return div.textContent || div.innerText || '';
    } catch {
        // Fallback for non-browser environments or errors
        return String(html || '').replace(/<[^>]*>?/gm, '');
    }
};
